import { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";

const LEGACY_TOKEN_KEY = "cvc_auth_token";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // null = checking, false = logged out, object = user
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    try { localStorage.removeItem(LEGACY_TOKEN_KEY); } catch { /* storage disabled */ }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = useCallback(async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  }, []);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.warn("Logout request failed", e?.message); }
    setUser(false);
  }, []);

  const value = useMemo(() => ({ user, login, logout, refresh }), [user, login, logout, refresh]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
